import { jsx as _jsx } from "react/jsx-runtime";
import { normalizeStyle } from '../server/layout/Box/Box';
export function CardGrid({ cols, min = 'md', gap = 'lg', children, style, }) {
    const resolvedGap = `var(--space-${gap})`;
    const minValue = typeof min === 'number' ? `${min}px` : `var(--card-grid-min-${min})`;
    const gridTemplateColumns = cols !== undefined
        ? `repeat(${cols}, minmax(0, 1fr))`
        : // `min(100%, …)` lets a single column shrink below `minValue` when the
            // container is narrower than it (mobile / clipped column) instead of
            // overflowing and getting clipped. On wide containers it equals
            // `minValue`, so multi-column behavior is unchanged.
            `repeat(auto-fill, minmax(min(100%, ${minValue}), 1fr))`;
    return (_jsx("div", { style: {
            display: 'grid',
            gridTemplateColumns,
            rowGap: resolvedGap,
            columnGap: resolvedGap,
            ...normalizeStyle(style),
        }, children: children }));
}
//# sourceMappingURL=CardGrid.js.map